// extracted by mini-css-extract-plugin
export default {"ManageLayersContainer":"ManageLayers_ManageLayersContainer__ZXcfs","EmptyWrapper":"ManageLayers_EmptyWrapper__vy5z6"};